import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/ThumbsDown.es.js";
const m = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...e, weights: t }));
m.displayName = "ThumbsDownIcon";
const c = m;
export {
  c as ThumbsDown,
  m as ThumbsDownIcon
};
